import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { ClubLobbyGuard } from './core/guards/clubLobby.guard';
import { TermsGuard } from './core/guards/terms.guard';
import { GamePageGuard } from './core/guards/game.guard';
import { NavigateClubGuard } from './core/guards/navigate-club.guard';
import { MobileWebGuard } from './core/guards/mobile-web.guard';

const routes: Routes = [
    {
        path: '',
        canActivateChild: [MobileWebGuard],
        children: [
            {
                path: '',
                redirectTo: 'lobby',
                pathMatch: 'full'
            },
            {
                path: 'lobby',
                loadChildren: () => import('./lobby/pages/lobby-home/lobby-home.module').then(m => m.LobbyHomePageModule),
                canActivate: [AuthGuard, TermsGuard, NavigateClubGuard],
            },
            {
                path: 'social',
                loadChildren: () => import('./messenger/pages/social-tabs/social-tabs.module').then(m => m.SocialTabsPageModule),
                canActivate: [AuthGuard],
            },
            {
                path: 'rewards',
                loadChildren: () => import('./rewards/rewards.module').then(m => m.RewardsModule),
                canActivate: [AuthGuard],
            },
            {
                path: 'points',
                loadChildren: () => import('./freeroll-eligibility-points/freeroll-eligibility-points.module').then(m => m.FreerollEligibilityPointsModule),
                canActivate: [AuthGuard],
            },
            {
                path: 'login',
                pathMatch: 'full',
                loadChildren: () => import('./account/pages/login/login.module').then(m => m.LoginPageModule),
            },
            {
                path: 'tournament-registration/:clubId/:tId',
                loadChildren: () => import('./game/page/tournament-registration/tournament-registration.module').then(m => m.TournamentRegistrationPageModule),
                canActivate: [TermsGuard],
            },
            {
                path: 'game-select',
                loadChildren: () => import('./game/page/game-select/game-select.module').then(m => m.GameSelectPageModule),
            },
            {
                path: 'game',
                loadChildren: () => import('./game/page/game/game.module').then(m => m.GamePageModule),
                canActivate: [GamePageGuard, TermsGuard]
            },
            {
                path: 'club-lobby/:id',
                loadChildren: () => import('./club/pages/club-lobby/club-lobby.module').then(m => m.ClubLobbyPageModule),
                canActivate: [AuthGuard,ClubLobbyGuard],
            },
            {
                path: 'reports',
                loadChildren: () => import('./club/pages/reports/reports.module').then(m => m.ReportsPageModule),
                canActivate: [AuthGuard],
            },
            {
                path: 'profit-loss',
                loadChildren: () => import('./club/pages/club-report/club-report.module').then(m => m.ClubReportPageModule),
                canActivate: [AuthGuard],
            },
            {
                path: 'profit-burn',
                loadChildren: () => import('./club/pages/club-profit-burn/club-profit-burn.module').then(m => m.CubProfitBurnPageModule),
                canActivate: [AuthGuard],
            },

            {
                path: 'reconcile-profit',
                loadChildren: () => import('./club/pages/member-detailed-report/member-detailed-report.module').then(m => m.MemberDtailedReportPageModule),
                canActivate: [AuthGuard],
            },
            {
                path: 'trade-record',
                loadChildren: () => import('./club/pages/club-trade-record/club-trade-record.module').then(m => m.ClubTradeRecordPageModule),
                canActivate: [AuthGuard],
            },
            {
                path: 'ended-tournaments',
                loadChildren: () => import('./club/pages/ended-tournaments/ended-tournaments.module').then(m => m.EndedTournamentsPageModule),
                canActivate: [AuthGuard],
            },
            {
                path: 'shop-home',
                loadChildren: () => import('./shop/pages/shop-home/shop-home.module').then(m => m.ShopHomePageModule),
            },
            {
                path: 'limit-select/:gameType',
                loadChildren: () => import('./game/page/limit-select/limit-select.module').then(m => m.LimitSelectPageModule),
            },
            {
                path: 'conversation/:conversationId',
                loadChildren: () => import('./messenger/pages/conversation/conversation.module').then(m => m.ConversationPageModule),
            },
            {
                path: 'test-dialog-input',
                loadChildren:
                    () => import('./shared/services/dialog-input/pages/test-dialog-input/test-dialog-input.module').then(m => m.TestDialogInputPageModule),
            },
            {
                path: 'club-lobby-member',
                loadChildren: () => import('./club/pages/club-lobby-member/club-lobby-member.module').then(m => m.ClubLobbyMemberPageModule),
            },
            {
                path: 'club-lobby-owner',
                loadChildren: () => import('./club/pages/club-lobby-owner/club-lobby-owner.module').then(m => m.ClubLobbyOwnerPageModule),
            },
            {
                path: 'club-lobby-manager',
                loadChildren: () => import('./club/pages/club-lobby-manager/club-lobby-manager.module').then(m => m.ClubLobbyManagerPageModule),
            },
            {
                path: 'club-lobby-agent',
                loadChildren: () => import('./club/pages/club-lobby-agent/club-lobby-agent.module').then(m => m.ClubLobbyAgentPageModule),
            },
            {
                path: 'agree-terms',
                loadChildren: () => import('./account/pages/agree-terms/agree-terms.module').then( m => m.AgreeTermsPageModule)
            },
            {
                path: 'update-password',
                loadChildren: () => import('./account/pages/update-password/update-password.module').then( m => m.UpdatePasswordPageModule),
                canActivate: [AuthGuard],
            },
            {
            path: 'password-change',
            loadChildren: () => import('./account/pages/password-change/password-change.module').then( m => m.PasswordChangePageModule)
            },
            {
                path: 'desktop-login',
                loadChildren: () => import('./account/pages/desktop-login/desktop-login.module').then(m => m.DesktopLoginPageModule)
            },
            {
                path: 'phantom-connect',
                loadChildren: () => import('./account/pages/phantom-connect/phantom-connect.module').then(m => m.PhantomConnectPageModule),
            },
            {
                path: 'tournament-queue/:gameConfigId',
                loadChildren: () => import('./game/page/tournament-queue/tournament-queue.module').then(m => m.TournamentQueuePageModule),
    },
        ]
    },
    {
        path: 'coinflow-checkout',
        loadChildren: () => import('./checkout/coinflow-checkout.module').then(m => m.CoinflowCheckoutModule),
    },
    {
        path: 'mobile-web-prompt',
        loadChildren: () => import('./mobile-web-prompt/mobile-web-prompt.module').then(m => m.MobileWebPromptModule),
    },
    {
        path: 'verification',
        loadChildren: () => import('./verification-page/verification-page.module').then(m => m.VerificationPageModule)
    },
    { path: '**', redirectTo: 'lobby', pathMatch: 'full' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
